import { useCallback } from 'react';

import { useAuth } from '../useAuth';
import { type Action, can as canBase } from './permissions';

export function usePermissions() {
  const { user } = useAuth();
  const can = useCallback((action: Action) => canBase(user, action), [user]);
  return { can };
}
